// extracted by mini-css-extract-plugin
export default {"wrapper":"LogIn_wrapper__PdZMG","content":"LogIn_content__FEcRZ","title":"LogIn_title__QO90D","mb":"LogIn_mb__e-rY+","text":"LogIn_text__fhoT3"};